/**
 * @param {import('../../type-definitions').SearchResult} result - search result
 * @returns {string} - load more button HTML
 */
export default result => {
    if (!result) {
        return '';
    }
    const {numTotalResults, page, nextPage, refinementURLBuilder} = result;
    const loadMoreText = window.Resources.SEARCH_LOAD_MORE.replace(
        '{0}',
        window.SitePreferences.DEFAULT_PAGE_SIZE * page
    ).replace('{1}', numTotalResults);
    return `
        ${
            nextPage !== null
                ? `
                <div class="show-more-products-button">
                    <button class="button button-custom-black outline"
                        data-next-page-url="${refinementURLBuilder.getNextPageURL(nextPage)}">
                        <span class="show-more-products-placeholder" data-loading-state="unloaded">
                            <!-- empty -->
                        </span>
                        <span class="load-more-text">${loadMoreText}</span>
                    </button>
                </div>
                `
                : ''
        }
    `;
};
